import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GenericFormComponent } from './generic-form.component';

@NgModule({
  declarations: [GenericFormComponent],
  imports: [CommonModule],
  exports: [GenericFormComponent]
})
export class GenericFormModule {}
